import Vue from 'vue'
import Router from 'vue-router'
const loading = r => require.ensure([], () => r(require('../pages/loading')), 'loading')
const index = r => require.ensure([], () => r(require('../pages/index')), 'index')
const shopCar = r => require.ensure([], () => r(require('../pages/shopCar')), 'shopCar')
const orderDetails = r => require.ensure([], () => r(require('../pages/orderDetails')), 'orderDetails')
const addressSet = r => require.ensure([], () => r(require('../pages/addressSet')), 'addressSet')
const addAddress = r => require.ensure([], () => r(require('../pages/addAddress')), 'addAddress')
const shopCarAccount = r => require.ensure([], () => r(require('../pages/shopCarAccount')), 'shopCarAccount')
const goodsDetails = r => require.ensure([], () => r(require('../pages/goodsDetails')), 'goodsDetails')
const myOrder = r => require.ensure([], () => r(require('../pages/myOrder')), 'myOrder')
const searchGoods = r => require.ensure([], () => r(require('../pages/searchGoods')), 'searchGoods')
const doctorIndex = r => require.ensure([], () => r(require('../pages/doctorIndex')), 'doctorIndex')
const doctorOrder = r => require.ensure([], () => r(require('../pages/doctorOrder')), 'doctorOrder')

Vue.use(Router)

const router = new Router({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition // 后退/前进 按钮时
    } else {
      return { x: 0, y: 0 } // 滚动到顶部
    }
  },
  routes: [
    { // 重定向到首页
      path: '/loading',
      redirect: { name: 'loading' }
    },
    { // 首页
      path: '/',
      name: 'loading',
      meta: { title: '' },
      component: loading
    },
    { // 首页
      path: '/index',
      name: 'index',
      meta: { title: '首页' },
      component: index
    },
    { // 购物车
      path: '/shopCar',
      name: 'shopCar',
      meta: { title: '购物车' },
      component: shopCar
    },
    { // 订单详情
      path: '/orderDetails/:id?',
      name: 'orderDetails',
      meta: { title: '订单详情' },
      component: orderDetails,
      props: true
    },
    {// 地址设置
      path: '/addressSet',
      name: 'addressSet',
      meta: { title: '地址' },
      component: addressSet
    },
    {// 添加地址
      path: '/addAddress',
      name: 'addAddress',
      meta: { title: '添加地址' },
      component: addAddress
    },
    {// 购物车结算
      path: '/shopCarAccount',
      name: 'shopCarAccount',
      meta: { title: '确认订单' },
      component: shopCarAccount
    },
    {// 商品详情
      path: '/goodsDetails/:id?',
      name: 'goodsDetails',
      meta: { title: '商品详情' },
      component: goodsDetails
    },
    {// 我的订单
      path: '/myOrder',
      name: 'myOrder',
      meta: { title: '我的订单' },
      component: myOrder
    },
    {// 商品搜索
      path: '/searchGoods',
      name: 'searchGoods',
      meta: { title: '商品搜索' },
      component: searchGoods
    },
    {// 医生端首页
      path: '/doctorIndex',
      name: 'doctorIndex',
      meta: { title: '首页' },
      component: doctorIndex
    },
    {// 医生端订单
      path: '/doctorOrder',
      name: 'doctorOrder',
      meta: { title: '本月订单' },
      component: doctorOrder
    }
  ]
})

router.beforeEach((to, from, next) => { // beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js